module.exports = __webpack_public_path__ + "static/media/UserManualCSM.88336013.pdf";